import {
    CHANGE_LOCALE,
    SWITCH_THEME,
    TOGGLE_COLLAPSED_NAV
} from "../constants/Theme";
  
  
  export function onLocaleChange(locale) {
    return {
      type: CHANGE_LOCALE,
      locale,
    };
  }
  
  export function onSwitchTheme(currentTheme) {
    return {
      type: SWITCH_THEME,
      currentTheme,
    };
  }
  export function toggleCollapsedNav(navCollapsed) {
    return {
      type: TOGGLE_COLLAPSED_NAV,
      navCollapsed,
    };
  }